import { ChartDataResponse, MetricInfo, DimensionInfo } from "@api/common";

export interface PieData {
    value: number;
    color: string;
}

export function toPieData(data: ChartDataResponse, metric: MetricInfo, dimensions: DimensionInfo[]): PieData[] {
    const metricData = data.metrics.find(m => m.metric === metric.metric);
    if (!metricData) {
        return [];
    }

    return dimensions.map(d => {
        const dataItem = metricData.data.find(item => item["dimension-values"].indexOf(d.dimension) !== -1);
        return {
            color: d.color,
            value: dataItem ? dataItem["metric-value"] : 0
        } as PieData;
    });
}
